/* Tysk katalog for locale-settings-integrations-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'set.integr.wooImported': '{orders} Verkaufs- und Rückgabeereignisse importiert',
  'set.integr.wooLastSync': 'Zuletzt synchronisiert {date}',
  'set.integr.wooDisconnectTitle': 'WooCommerce trennen',
  'set.integr.wooDisconnectHelp': 'Plumme ruft keine neuen Bestellungen und Rückgaben mehr ab. Bereits importierte Ereignisse und gebuchte Tagesabschlüsse bleiben mit Prüfpfad erhalten.',
  'set.integr.wooDisconnectedToast': 'WooCommerce wurde getrennt.',
  'set.integr.wooDisconnectError': 'WooCommerce konnte nicht getrennt werden.',
  'set.integr.wooUnavailable': 'Die WooCommerce-Integration ist in dieser Version nicht verfügbar.',
});
